import React, { useCallback, useState } from "react";

import Connected from "components/person/Connected";
import FetchingConnection from "../dashboard/FetchingConnection";
import ConnectButton from "../dashboard/ConnectButton";
import ConnectionUser from "../dashboard/ConnectionUser";

const Connection = ({ connected, handleUnfollow, onConnect, user }) => (
  <>
    <ConnectionUser user={user}>
      {
        connected
          ? <Connected user={user} handleUnfollow={handleUnfollow} />
          : <ConnectButton user={user} onConnect={onConnect} />
      }
    </ConnectionUser>
  </>
);

const BuildConnection = ({
  connection,
  fetching,
  users: connections,
  profile = undefined
}) => {
  const [connected, setConnected] = useState(profile?.connection?.connected || false);
  const [userDisconnected, setUserDisconnected] = useState(false);
  const onConnect = useCallback(
    () => {
      setUserDisconnected(false);
      setConnected(true);
    }, [setConnected]
  );

  const handleUnfollow = useCallback(
    () => {
      setConnected(false);
      setUserDisconnected(true);
    }, [setConnected]
  );

  if (fetching) {
    return <FetchingConnection />;
  }

  if (connection) {
    const { user } = connection;
    if (userDisconnected) {
      return (
        <Connection
          handleUnfollow={handleUnfollow}
          onConnect={onConnect}
          user={user}
        />
      );
    }

    const { users } = connections;
    const found = users.find(element => element.id === user.id);

    return (
      <Connection
        connected={found || connected}
        handleUnfollow={handleUnfollow}
        onConnect={onConnect}
        user={user}
      />
    );
  }

  if (profile) {
    return (
      <>
        {
          connected
            ? <Connected user={profile} handleUnfollow={handleUnfollow} />
            : <ConnectButton user={profile} onConnect={onConnect} />
        }
      </>
    );
  }

  return null;
};

export default BuildConnection;
